export default "__VITE_ASSET__BowyORyH__"